export default {
  NOT_FOUND: "NOT_FOUND",
  INACTIVE: "INACTIVE",
  NOT_VERIFIED: "NOT_VERIFIED",
  VERIFIED: "VERIFIED",
  ALREADY_VERIFIED: "ALREADY_VERIFIED",
  ACTIVE: "ACTIVE",
  TOKEN_EXPIRED: "TOKEN_EXPIRED",
  INVALID_TOKEN: "INVALID_TOKEN"
};